module.exports = __webpack_public_path__ + "static/img/ka.eda302aa.jpg";